import React, { useState } from 'react';
import HeaderDropdownButton from './HeaderDropdownButton';
import HeaderDropdownText from './HeaderDropdownText';

interface HeaderDropdownProps {
	text?: string;
	list: JSX.Element[];
	anchorOrigin: 'left' | 'right' | 'center';
	children?: React.ReactNode;
	cy: string;
}

const HeaderDropdown = ({
	text,
	list,
	anchorOrigin = 'left',
	children,
	cy,
}: HeaderDropdownProps): JSX.Element => {
	const [menuOpen, setMenuOpen] = useState(false);

	return (
		<>
			{text && (
				<HeaderDropdownText
					text={text}
					openMenu={() => setMenuOpen(true)}
				/>
			)}
			{children}
			{list && (
				<HeaderDropdownButton
					setMenuOpen={setMenuOpen}
					menuOpen={menuOpen}
					list={list}
					anchorOrigin={anchorOrigin}
					cy={cy}
				/>
			)}
		</>
	);
};

export default HeaderDropdown;
